var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72135 1.05365C8.8973 0.965677 9.10441 0.965677 9.28036 1.05365L16.6685 4.74774C16.8803 4.85361 17.014 5.07003 17.014 5.30676C17.014 5.54349 16.8803 5.75991 16.6685 5.86578L9.28036 9.55987C9.10441 9.64785 8.8973 9.64785 8.72135 9.55987L1.33317 5.86578C1.12143 5.75991 0.987676 5.54349 0.987676 5.30676C0.987676 5.07003 1.12143 4.85361 1.33317 4.74774L8.72135 1.05365ZM3.01022 5.30676L9.00086 8.30208L14.9915 5.30676L9.00086 2.31144L3.01022 5.30676ZM1.05367 12.4154C1.20804 12.1067 1.58346 11.9816 1.89219 12.1359L9.00086 15.6903L16.1095 12.1359C16.4183 11.9816 16.7937 12.1067 16.9481 12.4154C17.1024 12.7242 16.9773 13.0996 16.6686 13.254L9.28037 16.948C9.10442 17.036 8.89731 17.036 8.72136 16.948L1.33318 13.254C1.02444 13.0996 0.8993 12.7242 1.05367 12.4154ZM1.89219 8.44183C1.58346 8.28746 1.20804 8.4126 1.05367 8.72134C0.8993 9.03007 1.02444 9.4055 1.33318 9.55986L8.72136 13.254C8.89731 13.3419 9.10442 13.3419 9.28037 13.254L16.6686 9.55986C16.9773 9.4055 17.1024 9.03007 16.9481 8.72134C16.7937 8.4126 16.4183 8.28746 16.1095 8.44183L9.00086 11.9962L1.89219 8.44183Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.1997c39f6fb9ab12b7a1f1f5a15e2fc3.svg";
export { ForwardRef as ReactComponent };